import { RegisteredComponent } from "@builder.io/sdk-react";

export const dialogBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Dialog",
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  inputs: [
    {
      name: "isOpen",
      type: "boolean",
      localized: false,
      defaultValue: false,
    },
  ],
};
